import cookie from 'cookie';
import get from 'lodash.get';
import {emitEdapEvent, EVENTS} from '../utils/emit-edap-event';
import {trackUserPreferenceCCPA} from '../utils/compliance-policy';
import {EU_SITE_COOKIE_NAME, CCPA_STATE_COOKIE_NAME, ADS_REFRESH_EVENT, GDPR_COOKIE_NAME} from '../constants';

export const onDestinationChange = ({gaiaId, clearPrevTargeting = false}) => {
    // Accept gaiaId as string OR empty string that signals of missed value
    if (window.meso && window.meso.targeting && (gaiaId || gaiaId === '')) {
        if (clearPrevTargeting) {
            window.meso.targeting.push({type: 'clear'});
        }
        window.meso.targeting.push({adinfo: {dest: gaiaId}});
    }
};

export const onPageUpdate = () => {
    if (typeof window.CustomEvent === 'function') {
        document.dispatchEvent(new CustomEvent(ADS_REFRESH_EVENT));
    } else {
        // IE11 fallback for custom events
        const customEvent = document.createEvent('CustomEvent');
        customEvent.initCustomEvent(ADS_REFRESH_EVENT, true, true, {});
        document.dispatchEvent(customEvent);
    }
};

export const onAdsContextInit = ({brandId, locale, havId, gaiaId}) => {
    window.meso = window.meso || {};
    window.meso.logging = window.meso.logging || [];
    window.meso.targeting = window.meso.targeting || [];
    window.meso.initialize = window.meso.initialize || [];
    window.meso.breakpoints = window.meso.breakpoints || [];

    const cookies = cookie.parse(document.cookie);
    const isEU = cookies[EU_SITE_COOKIE_NAME] === '1';
    const isGDPR = cookies[GDPR_COOKIE_NAME] === 'functional:1';
    const canSell = !(cookies[CCPA_STATE_COOKIE_NAME] === 'true');

    const pagetype = get(window, 'analyticsdatalayer.pagetype');
    const isLoggedIn = get(window, 'analyticsdatalayer.publicuuid', '-1') !== '-1';

    const pageId = `Vrbo.${pagetype}`;

    if (window.meso.logging.length === 0) {
        window.meso.logging.push(`Adblock: ${window.adblock}`);
    }

    if (isLoggedIn && !canSell) {
        trackUserPreferenceCCPA();
    }

    document.cookie = cookie.serialize('DUAID', havId);

    window.meso.breakpoints.push({ type: 'platform', platform: 'vrbo' });

    window.meso.initialize.push({
        pageId,
        type: 'target',
        siteId: brandId,
        variant: 'default',
        locale: locale && locale.replace('-', '_'),
        canTrack: isEU ? isGDPR : true,
        canSell
    });

    onDestinationChange({gaiaId});
};
